import * as React from 'react';
import { Button, Form, Stack } from 'react-bootstrap';
import { getConfigOrThrow } from 'gossamer-front-end';

interface FeedbackDateRangeExportProps {
  endpointPath: string;
}

const formatDateInputValue = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getDefaultEndDate = (): string => {
  return formatDateInputValue(new Date());
};

export const FeedbackDateRangeExport = ({ endpointPath }: FeedbackDateRangeExportProps) => {
  const [startDate, setStartDate] = React.useState('2020-01-01');
  const [endDate, setEndDate] = React.useState(getDefaultEndDate);
  const isDateRangeValid = !!startDate && !!endDate && startDate <= endDate;
  const downloadUrl = `${getConfigOrThrow('gossamer-be-origin')}${getConfigOrThrow(
    'gossamer-api-path',
  )}${endpointPath}?start_date=${encodeURIComponent(startDate)}&end_date=${encodeURIComponent(endDate)}`;

  return (
    <>
      <p>CSV files can be uploaded into spreadsheet applications such as Microsoft Excel or Google Sheets.</p>
      <Stack direction="horizontal" gap={3} style={{ alignItems: 'flex-end', flexWrap: 'wrap' }}>
        <Form.Group controlId="feedback-export-start-date">
          <Form.Label>Start date</Form.Label>
          <Form.Control
            type="date"
            value={startDate}
            max={endDate}
            onChange={(event) => setStartDate(event.currentTarget.value)}
          />
        </Form.Group>
        <Form.Group controlId="feedback-export-end-date">
          <Form.Label>End date</Form.Label>
          <Form.Control
            type="date"
            value={endDate}
            min={startDate}
            onChange={(event) => setEndDate(event.currentTarget.value)}
          />
        </Form.Group>
        <Button as="a" size="sm" href={downloadUrl} download disabled={!isDateRangeValid}>
          Download feedback CSV
        </Button>
      </Stack>
    </>
  );
};
